import { useNavigate } from "react-router-dom";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";
import useGetHomepageInfo from "../hooks/useGetHomepageInfo";
// import "./PreviewProjects.css";

// Maps an award label to its badge style class and medal icon.
const awardMeta = (award) => {
  switch ((award || "").toLowerCase()) {
    case "1st place":
      return { cls: "award-1st", icon: "🥇" };
    case "2nd place":
      return { cls: "award-2nd", icon: "🥈" };
    case "3rd place":
      return { cls: "award-3rd", icon: "🥉" };
    case "discovery":
      return { cls: "award-discovery", icon: "🔭" };
    case "seeds":
      return { cls: "award-seeds", icon: "🌱" };
    default:
      return { cls: "award-default", icon: "★" };
  }
};

function PreviewProjectsMobile() {
  const navigate = useNavigate();

  const { homepageInfo } = useGetHomepageInfo();

  const previewData = homepageInfo?.previews || [];

  return (
    <div className="w-full mt-8 text-xl sm:hidden">
      <h1 className="preview-header font-light">Explore Inspiring Projects</h1>
      <Carousel className="w-full mt-4 overflow-hidden">
        <CarouselContent className="-ml-4">
          {previewData.slice(0, 8).map((project, index) => {
            const meta = awardMeta(project.award);
            return (
              <CarouselItem key={index}>
                <div
                  onClick={() => navigate(`/projects/${project._id}`)}
                  className="w-full"
                >
                  <div className="relative">
                    <img
                      src={project.previewImage?.asset.url || "/assets/neu-N.png"}
                      alt={project.previewImage?.alt || "Project Image"}
                      className="w-full object-cover aspect-[16/10]"
                    />
                    {project.award && (
                      <span
                        className={`award-badge ${meta.cls}`}
                        style={{ position: "absolute", top: 10, left: 10 }}
                      >
                        <span className="award-icon">{meta.icon}</span>
                        {project.award}
                      </span>
                    )}
                  </div>
                  <div className="mt-4">
                    <h1 className="text-lg text-left line-clamp-4 px-4 font-bold">
                      {project.title}
                    </h1>
                  </div>
                </div>
              </CarouselItem>
            );
          })}
        </CarouselContent>
        <CarouselPrevious className="" />
        <CarouselNext className="" />
      </Carousel>
    </div>
  );
}

export default PreviewProjectsMobile;
